module.exports = __webpack_public_path__ + "static/bilo-bilo-276e6f058a6c609140f89e3ab8204e13.jpg";